<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">推广员管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="160px" class="user-search">
            <el-form-item label="推广员名称">
                <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="推广员注册手机号">
                <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="nickname" label="推广员名称" ></el-table-column>
            <el-table-column  prop="nickname" label="是否认证" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" label="手机号" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="bindMachineNum" label="绑定机器" ></el-table-column>
            <el-table-column  prop="createdAt" label="注册时间">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="parentName" label="所属上级" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="总经销商详情" :visible.sync="detailsFlag" width="30%" @click="closeDialog">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions column="1">
                        <el-descriptions-item label="推广员名称">{{ editForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{ editForm.phone }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ editForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="所属上级">{{ editForm.parentName }}</el-descriptions-item>
                        <el-descriptions-item label="分成比例">推广员将从总经销商收益中（扣完手续费）分得{{ editForm.division }}%</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane label="认证信息" name="attestation">
                    <el-descriptions column="1">
                        <template slot="extra">
                            <el-button type="primary" size="small" @click="editClick">编辑</el-button>
                        </template>
                        <el-descriptions-item label="经销商名称">{{ editForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{editForm.phone}}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ editForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="分成比例">{{ editForm.createdAt|timestampToTime }}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="总经销商详情" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machineData" @selection-change="handleSelectionChange" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="主屏id" label="主屏id" ></el-table-column>
                    <el-table-column  prop="机器状态" label="机器状态" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadStoreUserList , loadCustomerList } from '../../../api/userMG'
export default {
    data(){
        return{
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        handleEdit(index , row){
            this.detailsFlag = true
            this.editForm = row
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadStoreUserList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                name:this.formInline.name,
                phone:this.formInline.phone,
                userType:'3'
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/MerchantManagement/Promoter.vue